import { Decimal, Money } from "classes/DecimalClasses";

export const FIELDS_TO_TRANSFORM = {
  DECIMAL_FIELDS: ["quantity", "baseVolume", "baseWeight", "volume", "weight"],
  MONEY_FIELDS: ["cost", "total"],
  DATE_FIELDS: [],
  DATETIME_FIELDS: [],
  NON_UTC_DATETIME_FIELDS: [],
};

export const EMPTY_LINE = {
  lineId: "",
  lineNumber: "",
  componentItem: null,
  description: null,
  quantity: Decimal.ZERO,
  cost: new Money(0),
  total: new Money(0),
  typeOfItem: null,
  baseWeight: Decimal.ZERO,
  weight: Decimal.ZERO,
  weightUnit: "lb",
  baseVolume: Decimal.ZERO,
  volume: Decimal.ZERO,
  volumeUnit: "cbm",
  notes: null,
};
